/** @format */

import {Trans} from 'react-i18next';

import {HelpContentBox, HelpContentText} from '../../styles';

const BudgetHelpContent = (
  <HelpContentBox>
    <HelpContentText>
      <Trans>
        При превышении совокупного месячного рекламного бюджета по всем подключенным к AdSensor
        клиентским аккаунтам Яндекс Директа, указанного в вашем тарифном плане, тарифный план
        автоматически будет изменен на тарифный план, соответствующий уровню совокупного месячного
        рекламного бюджета и автоматически будет осуществлено списание недостающих средств с вашего
        баланса в личном кабинете.
      </Trans>
    </HelpContentText>
  </HelpContentBox>
);

export {BudgetHelpContent};
